const avatar = "_avatar_zysgz_8";
const image = "_image_zysgz_43";
const styles = {
  avatar,
  image,
  "avatar-imageless": "_avatar-imageless_zysgz_55",
  "stacked-avatars": "_stacked-avatars_zysgz_109",
  "clip-path": "_clip-path_zysgz_128"
};
export {
  avatar,
  styles as default,
  image
};
//# sourceMappingURL=Avatar.module.css.js.map
